export default __webpack_public_path__ + "static/media/axentra_logo.9e82a0f1.png";